import React from 'react';
import { useAppSelector } from '../../store/store';
import './_pagination.scss';

type PaginationProps = {
  onChange: (page: 'next' | 'prev') => Promise<void>;
};

export default function Pagination(props: PaginationProps) {
  const { onChange } = props;
  const state = useAppSelector((state) => state.apiPage);
  const { prevPageToken, nextPageToken, totalResults, resultsPerPage } = state.homePageState;

  const onButtonClicked = (direction: 'next' | 'prev') => {
    onChange(direction);
  };

  const currentPage = state.pageNumber;
  const totalPages =
    totalResults && resultsPerPage ? Math.floor(totalResults / resultsPerPage) : null;
  return (
    <div className="pagination__wrapper">
      <div className="pagination__page-count">{`${currentPage} of ${totalPages} pages`}</div>
      {prevPageToken && (
        <div className="pagination__button" onClick={() => onButtonClicked('prev')}>
          Prev page
        </div>
      )}
      {nextPageToken && (
        <div className="pagination__button" onClick={() => onButtonClicked('next')}>
          Next page
        </div>
      )}
    </div>
  );
}
